
import { Affix } from "../Misc/Misc";
import { useCallback, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTemplateStoreFromContext } from "./Context/hooks";
import { isSectionEmpty } from "./Template.helpers";
import { ContentItem, SectionContentItem } from "./types";
import { useShallow } from "zustand/react/shallow";
import { useReadFieldFromCache } from "./Context/hooks";

const TemplateNav = () => {
  // Use a more stable subscription pattern
  const store = useTemplateStoreFromContext();

  const { editMode, content } = store(
    useShallow(state => ({
      editMode: state.editMode,
      content: state.content,
    }))
  );

  const readFieldFromCache = useReadFieldFromCache();

  const { hash } = useLocation();

  // Memoize the getSections function to prevent unnecessary recalculations
  const getSections = useCallback(
    (contentItems: ContentItem[], isEditMode: boolean) => {
      return contentItems.filter(t => {
        if (t.type !== "section") return false;
        return !isSectionEmpty(t.content, readFieldFromCache) || isEditMode;
      });
    },
    [readFieldFromCache]
  );

  // Memoize the sections to prevent unnecessary re-renders
  const sections = useMemo(
    () => getSections(content, editMode),
    [content, editMode, getSections]
  );

  return (
    // Sticky offset comes from .anchor-bar__wrap so it can shift up with the navbar.
    <Affix className="anchor-bar__wrap">
      <div className="anchor-bar">
        <ul className="anchor-bar__menu">
          {(sections as SectionContentItem[]).map(section => (
            <li className="anchor-bar__menu-item" key={section.display_name}>
              <Link
                to={`#${section.display_name?.replace(/\s/g, "")}${
                  hash.slice(1) === section.display_name?.replace(/\s/g, "")
                    ? "_RETURN"
                    : ""
                }`}
                style={{ width: "100%" }}
              >
                {section.display_name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Affix>
  );
};

export default TemplateNav;
